import { FORM_ERROR } from 'final-form';

import { ApiError } from './types';
import getMessageFromApiError, { getMessageSlugFromApiError, isApiError } from './utils';

export const handleApiErrorsSlugs = (state: Record<string, any>) => (error: ApiError) => {
  const { errors = {} } = state;

  if (isApiError(error)) {
    const message_slug = getMessageSlugFromApiError(error);

    return { ...state, errors: { ...errors, [message_slug]: getMessageFromApiError(error) } };
  }

  return { ...state, errors: { [FORM_ERROR]: error.message } };
};

export const applyErrorsToForm = (state: any) => {
  const { errors = {} } = state;

  if (!Object.keys(errors).length) {
    return;
  }

  const formError = Object.keys(errors).reduce(
    (acc, code) => (errors[code] ? errors[code] : acc),
    '',
  );

  return formError
    ? {
        [FORM_ERROR]: formError,
      }
    : undefined;
};
